import { type FunctionComponent } from 'react';
import { type SearchVariantFieldsFragment } from '../../../../__generated__/graphql-client-types';
import { type TrackedEvent } from '../../../../helpers/analytics/event-types';
import { SearchVariantSelector } from '../../../search-components/search-variant-selector/search-variant-selector.component';

export type SwatchesProps = {
	variants: SearchVariantFieldsFragment[];
	maxNumberToDisplay: number;
	isTileView: boolean;
	scrollEvent: TrackedEvent;
	selectEvent?: TrackedEvent;
	allowSingleVariant?: boolean;
	className?: string;
};

export const Swatches: FunctionComponent<SwatchesProps> = ({
	variants,
	maxNumberToDisplay,
	isTileView,
	scrollEvent,
	selectEvent,
	allowSingleVariant,
	className = ''
}) => {
	return (
		<div className={className}>
			{variants?.length > 1 && (
				<SearchVariantSelector
					variants={variants}
					maxNumberToDisplay={maxNumberToDisplay}
					isTileView={isTileView}
					scrollEvent={scrollEvent}
					selectEvent={selectEvent}
					allowSingleVariant={allowSingleVariant}
				/>
			)}
		</div>
	);
};
